module.exports = __webpack_public_path__ + "static/img/1011_big.f0bfc8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1011_big.png
// module id = 2Ha1
// module chunks = 1